import React, { useState } from "react";

const RefundPolicy = () => {
  const [rule, setRule] = useState([
    {
      liItem: `All items to be returned or exchanged must be unused and in their original condition with all original labels and packaging intact, and should not be broken or tampered with.`,
    },
    {
      liItem: `Exchanges are allowed only if your address is serviceable for an Exchange by our logistics team.`,
    },
    {
      liItem: `In case you had purchased a product which has a free gift/offer associated with it and you wish to return the item, maximum of Refunds/Free item MRP will be debited until the satisfactory receipt of all free gift(s)/offer item(s) that are shipped along with it.`,
    },
    {
      liItem: `If you choose to self-ship your returns, kindly pack the items securely to prevent any loss or damage during transit. For all self-shipped returns, we recommend you use a reliable courier service.`,
    },
    {
      liItem: `Perishable goods such as seeds and flowers cannot be returned, if the packet is opened or damaged.`,
    },
    {
      liItem: `Products must be returned within 07 days from the day of delivery, To return your purchase, please call customer care at +91-9654113661.`,
    },
  ]);
  const [missingRefund, setMissingRefund] = useState([
    {
      liItem: `If you haven’t received a refund yet, first check your bank account again.`,
    },
    {
      liItem: `Then contact your credit card company, it may take some time before your refund is officially posted.`,
    },
    {
      liItem: `Next contact your bank. There is often some processing time before a refund is posted.`,
    },
    {
      liItem: `If you’ve done all of this and you still have not received your refund yet, please contact us at info@farmerscity.in.`,
    },
  ]);
  return (
    <div className="py-5">
      <div className="container px-md-5">
        <h2 className="mb-0 ff_heebo fw-bold fs_6xl clr_dark_green">
          Refund Policy
        </h2>
        <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
          Farmer's City Return and Exchange Policy offers no return of goods
          once delivered. If you choose to exchange the item for reason of
          mismatch of product or receipt of a defective or expired item, you
          will be provided with a replacement of the item, free of cost.
          However, an exchange is subject to availability of the product in our
          stock.
        </p>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Use Given to the Information We Collect
          </h3>
          <div>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              We use the information we collect to provide intermediation
              services in the purchasing and selling of agricultural products
              and/or the supply and delivery of logistics and agricultural
              products and/or agricultural training or upskilling services. We
              may also use the information you have provided for the following
              purposes:
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {rule.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2">
                  <div className="policy-ul-li-dots mt-2"></div>
                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.liItem}
                  </p>
                </li>
              ))}
            </ul>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              To complete your return, we require a receipt or proof of
              purchase.
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              Please do not send your purchase back to the manufacturer.
            </p>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Refunds (if applicable)
          </h3>
          <div>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              Once your return is received and inspected, we will send you an
              email to notify you that we have received your returned item. We
              will also notify you of the approval or rejection of your refund.
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              If you are approved, then your refund will be processed, and a
              credit will automatically be applied to your credit card or
              original method of payment, within a 7 to 10 Working days.
            </p>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Late or missing refunds (if applicable)
          </h3>
          <div>
            <ul className="ps-3 mt-3 policy-ul">
              {missingRefund.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-1">
                  <div className="policy-ul-li-dots mt-2"></div>
                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.liItem}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Exchanges (if applicable)
          </h3>
          <div>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              We only replace items if they are defective or damaged. If you
              need to exchange it for the same item, send us an email at
              info@farmerscity.in and send your item to:
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              Farmer’s City International Pvt Ltd
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              (A subsidiary of AVPL International Ltd)
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              Plot No 251, Second Floor, Udyog Vihar, Phase IV, Gurgaon – 122015
            </p>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Governing Law
          </h3>
          <div>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              These terms shall be governed by and constructed in accordance
              with the laws of India without reference to conflict of laws
              principles and disputes arising in relation hereto shall be
              subject to the exclusive jurisdiction of the courts at Bangalore,
              Karnataka.
            </p>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_4xl clr_dark_green">
            Shipping
          </h3>
          <div>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              To return your product, you should mail your product to:
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              Farmer’s City International Pvt Ltd
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              (A subsidiary of AVPL International Ltd)
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-1">
              Plot No 251, Second Floor, Udyog Vihar, Phase IV, Gurgaon – 122015
            </p>
            <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
              You will be responsible for paying for your own shipping costs for
              returning your item. Shipping costs are non-refundable. If you
              receive a refund, the cost of return shipping will be deducted
              from your refund. Depending on where you live, the time it may
              take for your exchanged product to reach you, may vary.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
